import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface FollowupModalProps {
  isOpen: boolean;
  onRequestClose: (hasData?: boolean) => void;
  onSuccess: () => void;
  leadId?: string;
}

const FollowupModal: React.FC<FollowupModalProps> = ({
  isOpen,
  onRequestClose,
  onSuccess,
  leadId,
}) => {
  return (
    <Dialog open={isOpen} onClose={() => onRequestClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Log Follow-up Activity</DialogTitle>
      <DialogContent>
        <Typography>
          Follow-up modal for lead {leadId}. This will be implemented later.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onRequestClose()}>Cancel</Button>
        <Button variant="contained" onClick={onSuccess}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default FollowupModal;








